import { render } from "./interactiveDialogicLo.vue?vue&type=template&id=27a319f4"
import script from "./interactiveDialogicLo.vue?vue&type=script&lang=js"
export * from "./interactiveDialogicLo.vue?vue&type=script&lang=js"

import "./interactiveDialogicLo.vue?vue&type=style&index=0&id=27a319f4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__